/**
 * メールテンプレート管理用の Zod スキーマ
 */

import { z } from "zod";

// ============================================
// テンプレートID
// ============================================

export const EmailTemplateIdSchema = z.enum([
  "welcome",
  "login_notification",
  "magic_link",
  "purchase_receipt",
  "email_change_verify_current",
  "email_change_verify_new",
  "email_change_notification",
  "email_change_complete",
  "contact_notification",
  "contact_auto_reply",
]);

// ============================================
// テンプレート変数
// ============================================

export const EmailTemplateVariableSchema = z.object({
  name: z.string(),
  label: z.string(),
  description: z.string(),
  sampleValue: z.string(),
  required: z.boolean(),
});

// ============================================
// テンプレートデータ
// ============================================

export const EmailTemplateSchema = z.object({
  id: EmailTemplateIdSchema,
  name: z.string(),
  description: z.string(),
  subject: z.string().min(1, "件名は必須です").max(200, "件名は200文字以内で入力してください"),
  htmlContent: z.string().min(1, "HTMLコンテンツは必須です"),
  textContent: z.string().min(1, "テキストコンテンツは必須です"),
  variables: z.array(EmailTemplateVariableSchema),
  updatedAt: z.string(),
  updatedBy: z.string().nullable(),
  isCustomized: z.boolean(),
});

// ============================================
// API リクエスト/レスポンス
// ============================================

export const EmailTemplateUpdateRequestSchema = z.object({
  subject: z.string().min(1, "件名は必須です").max(200, "件名は200文字以内で入力してください"),
  htmlContent: z.string().min(1, "HTMLコンテンツは必須です"),
  textContent: z.string().min(1, "テキストコンテンツは必須です"),
});

export const EmailTemplatePreviewRequestSchema = z.object({
  variables: z.record(z.string(), z.string()),
});

export const EmailTemplatePreviewResponseSchema = z.object({
  subject: z.string(),
  html: z.string(),
  text: z.string(),
});

export const EmailTemplateListResponseSchema = z.object({
  templates: z.array(EmailTemplateSchema),
});

// ============================================
// 一斉通知
// ============================================

/** 一斉通知リクエストスキーマ */
export const BroadcastRequestSchema = z.object({
  subject: z.string().min(1).max(200),
  htmlContent: z.string().min(1),
  textContent: z.string().min(1),
});

// ============================================
// パラメータスキーマ（Presentation層用）
// ============================================

/** 問い合わせIDパラメータスキーマ */
export const ContactIdParamSchema = z.object({
  id: z.string().uuid(),
});

/** テンプレートIDパラメータスキーマ */
export const TemplateIdParamSchema = z.object({
  templateId: EmailTemplateIdSchema,
});
